export const environment = process.env.REACT_APP_ENV || 'production';

// @See https://www.figma.com/colors/light-green/ for color Name
export const globeConfigs = {
    'Retail Express': {
        urls: {
            uat: 'https://uatappasvsdb001.azurewebsites.net/api/order',
            staging: 'https://uatappasvsdb001.azurewebsites.net/api/order',
            production: 'https://retailworldorders.maropost.com/api/order'
        },
        salesChannels: {
            online:     'rgba(255, 181, 192, 0.7)', // Red (Light Pink)
            'in store': 'rgba(205,  28,  24, 0.7)', // Red  (Chili red)
            other:      'rgba(255, 255, 255, 0.7)' // White
        },
        archStyle: {
            dashLength: 0.7,
            dashGap: 1,
            dashAnimateTime: 5000,
            stroke: 0.1,
            gradientColor: null,
            gradientCount: 1
        }
    },
    'Neto Ecommerce': {
        urls: {
            uat: 'http://order-visualisation-uat-532224160.ap-southeast-2.elb.amazonaws.com/',
            staging: 'http://order-visualisation-staging-1857597936.ap-southeast-2.elb.amazonaws.com/',
            production: 'https://commerceworldorders-data.maropost.com/'
        },
        salesChannels: {
            'amazon au':     'rgba(255, 153,  28, 0.7)', // Orange (Bright Orange)
            'amazon us':     'rgba(255, 153,  28, 0.7)', // Orange (Bright Orange)
            'catch':           'rgba(255,  92,   0, 0.7)', // Orange (Neon orange)
            ebay:            'rgba(239, 191,   4, 0.7)', // Yellow (Gold)
            kogan:           'rgba(255, 191,   0, 0.7)', // Orange (Amber)
            'control panel': 'rgba(99,  149, 238, 0.7)', // Blue (Cornflower blue)
            'neto pos':      'rgba(128, 239, 128, 0.7)', // Green (Pastel green)
            website:         'rgba(  0, 187, 119, 0.7)', // Green (Jade Green)
            other:           'rgba(  0,  71, 171, 0.7)' // Blue (Cobalt blue)
        },
        archStyle: {
            dashLength: 0.5,
            dashGap: 1,
            dashAnimateTime: 5000,
            stroke: 0.1,
            gradientColor: null,
            gradientCount: 1
        }
    }
};

export const initConfigs = {
    pointOfView: { lat: -30, lng: 145, altitude: 1.5 },
    autoRotateSpeed: 0.1,
    countDown: '2024-12-03T00:00:00',
    totalCountAnimateTime: 7000,
    darkMode: true,
    highlightCountries: true,
    countriesAltitude: 0.002,
    countriesCapColor: 'rgba(0,50,100, .5)',
    countriesSideColor: 'rgba(0,0,0, 0.5)',
    countriesStrokeColor: 'rgba(150,150,150, 0.5)'
};

export default {
    CHANGE_DAY_TIME: 'CHANGE_DAY_TIME',
    UPDATE_ORDERS: 'UPDATE_ORDERS',
    UPDATE_PAGE_STATUS: 'UPDATE_PAGE_STATUS',
    UPDATE_AUTO_ROTATE: 'UPDATE_AUTO_ROTATE',
    PAGE_STATUS_LOADING: 'loading',
    PAGE_STATUS_LOADED: 'loaded',
    PAGE_STATUS_ERROR: 'error'
};
